import React from 'react';
import {theme} from 'antd';
import {getIn, useFormikContext} from 'formik';

// Shared validation-message renderer for every formik field, in the theme's
// colorError. Shown once the field was touched or a submit was attempted —
// fields missing from initialValues are never marked touched by Formik's
// submit, so relying on `touched` alone hid their errors while still
// blocking the submit.
const FieldError: React.FC<{name: string}> = ({name}) => {
  const {token} = theme.useToken();
  const {errors, touched, submitCount} = useFormikContext<any>();
  const msg = getIn(errors, name);
  if (!msg || !(getIn(touched, name) || submitCount > 0)) return null;
  return (
    <div style={{color: token.colorError, fontSize: 12, marginTop: 4}}>
      {typeof msg === 'string' ? msg : JSON.stringify(msg)}
    </div>
  );
};

export default FieldError;
